import { inject, Injectable } from '@angular/core';
import { ReportingImportSseEventPayload } from '@api-types/sse/event-payloads/reporting-import.sse-event-payload';
import { SseEventType } from '@api-types/sse/sse.types';
import { SseEventHandler } from '@core/sse/sse-event-handler';
import { ReportingImportEventService } from './reporting-import-event.service';

@Injectable()
export class ReportingImportSseHandler implements SseEventHandler<
  typeof SseEventType.ReportingImport
> {
  readonly eventType = SseEventType.ReportingImport;

  private readonly importEventService = inject(ReportingImportEventService);

  handle(payload: ReportingImportSseEventPayload): void {
    this.importEventService.emit(payload);
  }
}
